import { lighten } from "polished";
export const lightenCol = (color: string, amount = 0.2) => lighten(amount)(color);
